var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "slide" } }, [
    _vm.node && _vm.node.selected
      ? _c(
          "div",
          {
            staticClass: "cf-node-properties cf-node-properties--enhanced-form",
            on: {
              contextmenu: function($event) {
                $event.stopPropagation()
                $event.preventDefault()
              }
            }
          },
          [
            _c("div", { staticClass: "cf-node-properties__header" }, [
              _c("div", { staticClass: "cf-node-properties__title" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.node.displayName) + "\n        "
                ),
                _c("i", {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip.top",
                      value: _vm.node.nodeDescription,
                      expression: "node.nodeDescription",
                      modifiers: { top: true }
                    }
                  ],
                  staticClass: "fa fa-question-circle m-l-8",
                  attrs: { "aria-hidden": "true" }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cf-node__actions" }, [
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip.left.hover",
                        value: "Duplicate Node",
                        expression: "'Duplicate Node'",
                        modifiers: { left: true, hover: true }
                      }
                    ],
                    staticClass: "cf-node__action",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.duplicateNode($event, true)
                      }
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-copy",
                      attrs: { "aria-hidden": "true" }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip.left.hover",
                        value: "Delete Node",
                        expression: "'Delete Node'",
                        modifiers: { left: true, hover: true }
                      }
                    ],
                    staticClass: "cf-node__action m-l-15",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.deleteNode.apply(null, arguments)
                      }
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-trash",
                      attrs: { "aria-hidden": "true" }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip.left.hover",
                        value: "Close Settings",
                        expression: "'Close Settings'",
                        modifiers: { left: true, hover: true }
                      }
                    ],
                    staticClass: "cf-node__action m-l-15",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.closeNodeProperties.apply(null, arguments)
                      }
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-times",
                      attrs: { "aria-hidden": "true" }
                    })
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "cf-node-properties__content" },
              [
                _vm.hasErrors
                  ? _c("div", { staticClass: "cf-node-properties__errors" }, [
                      _c(
                        "ul",
                        [
                          _vm.generalErrors
                            ? _vm._l(_vm.generalErrors, function(error, index) {
                                return _c(
                                  "li",
                                  { key: `'gen-error-'${index}` },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(error) +
                                        "\n            "
                                    )
                                  ]
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.propertyErrors
                            ? _vm._l(_vm.propertyErrors, function(
                                error,
                                index
                              ) {
                                return _c(
                                  "li",
                                  { key: `'prop-error-${index}` },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(error.displayName) +
                                        " " +
                                        _vm._s(error.errorMessage) +
                                        ".\n            "
                                    )
                                  ]
                                )
                              })
                            : _vm._e()
                        ],
                        2
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "cf-node-properties__field" },
                  [
                    _c("label", { staticClass: "control-label" }, [
                      _vm._v("\n          Node Name\n          "),
                      _c("i", {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip.top",
                            value:
                              "A label that will be populated on top of the node with the selected name",
                            expression:
                              "'A label that will be populated on top of the node with the selected name'",
                            modifiers: { top: true }
                          }
                        ],
                        staticClass: "fa fa-question-circle m-l-5",
                        attrs: { "aria-hidden": "true" }
                      })
                    ]),
                    _vm._v(" "),
                    _c("InputText", {
                      on: {
                        input: _vm.onUpdateStepNameDelayed,
                        blur: _vm.onUpdateStepName
                      },
                      model: {
                        value: _vm.stepName,
                        callback: function($$v) {
                          _vm.stepName = $$v
                        },
                        expression: "stepName"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.node.nodeTypeId == "DialNode"
                  ? _c("DialNodeProps", {
                      key: `node-${_vm.node.id}`,
                      attrs: { node: _vm.nodeClone },
                      on: {
                        "update:node": function($event) {
                          _vm.nodeClone = $event
                        }
                      }
                    })
                  : _vm.node.nodeTypeId == "RouterNode"
                  ? _c("RouterNodeProps", {
                      key: `node-${_vm.node.id}`,
                      attrs: {
                        node: _vm.nodeClone,
                        scene: _vm.scene,
                        routes: _vm.routes
                      },
                      on: {
                        "update:node": function($event) {
                          _vm.nodeClone = $event
                        },
                        "update:routes": function($event) {
                          _vm.routes = $event
                        },
                        showContextMenu: _vm.showContextMenu
                      }
                    })
                  : _vm.node.nodeTypeId == "MenuNode"
                  ? _c("MenuNodeProps", {
                      key: `node-${_vm.node.id}`,
                      attrs: { node: _vm.nodeClone, routes: _vm.routes },
                      on: {
                        "update:node": function($event) {
                          _vm.nodeClone = $event
                        },
                        "update:routes": function($event) {
                          _vm.routes = $event
                        },
                        removeConnection: _vm.removeConnection,
                        showContextMenu: _vm.showContextMenu,
                        recreateLinks: _vm.recreateLinks
                      }
                    })
                  : _vm.node.nodeTypeId == "SplitTestNode"
                  ? _c("SplitTestNodeProps", {
                      key: `node-${_vm.node.id}`,
                      attrs: { node: _vm.nodeClone, routes: _vm.routes },
                      on: {
                        "update:node": function($event) {
                          _vm.nodeClone = $event
                        },
                        "update:routes": function($event) {
                          _vm.routes = $event
                        },
                        removeConnection: _vm.removeConnection,
                        showContextMenu: _vm.showContextMenu
                      }
                    })
                  : _vm.node.nodeTypeId == "PlayNode"
                  ? _c("PlayNodeProps", {
                      key: `node-${_vm.node.id}`,
                      attrs: { node: _vm.nodeClone },
                      on: {
                        "update:node": function($event) {
                          _vm.nodeClone = $event
                        }
                      }
                    })
                  : _vm.node.nodeTypeId == "GatherNode"
                  ? _c("GatherNodeProps", {
                      key: `node-${_vm.node.id}`,
                      attrs: { node: _vm.nodeClone },
                      on: {
                        "update:node": function($event) {
                          _vm.nodeClone = $event
                        }
                      }
                    })
                  : _vm.node.nodeTypeId == "HangupNode"
                  ? _c("HangupNodeProps", {
                      key: `node-${_vm.node.id}`,
                      attrs: { node: _vm.nodeClone },
                      on: {
                        "update:node": function($event) {
                          _vm.nodeClone = $event
                        }
                      }
                    })
                  : _vm.node.nodeTypeId == "JSNode"
                  ? _c("JsNodeProps", {
                      key: `node-${_vm.node.id}`,
                      attrs: { node: _vm.nodeClone },
                      on: {
                        "update:node": function($event) {
                          _vm.nodeClone = $event
                        }
                      }
                    })
                  : _vm.node.nodeTypeId == "GoToNode"
                  ? _c("GoToNodeProps", {
                      key: `node-${_vm.node.id}`,
                      attrs: {
                        node: _vm.nodeClone,
                        nodes: _vm.scene.nodes,
                        "selected-node-to-route": _vm.selectedNodeToRoute
                      },
                      on: {
                        "update:node": function($event) {
                          _vm.nodeClone = $event
                        },
                        goToNodeSelectMode: _vm.goToNodeSelectMode,
                        selectNode: _vm.selectNode
                      }
                    })
                  : _vm.node.nodeTypeId == "HoursOfOperationNode"
                  ? _c("HoursFilterNodeProps", {
                      key: `node-${_vm.node.id}`,
                      attrs: { node: _vm.nodeClone },
                      on: {
                        "update:node": function($event) {
                          _vm.nodeClone = $event
                        }
                      }
                    })
                  : _vm.node.nodeTypeId == "RecordNode"
                  ? _c("RecordNodeProps", {
                      key: `node-${_vm.node.id}`,
                      attrs: { node: _vm.nodeClone },
                      on: {
                        "update:node": function($event) {
                          _vm.nodeClone = $event
                        }
                      }
                    })
                  : _c("GenericNodeProps", {
                      key: `node-${_vm.node.id}`,
                      attrs: { node: _vm.nodeClone },
                      on: {
                        "update:node": function($event) {
                          _vm.nodeClone = $event
                        }
                      }
                    }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "cf-node-properties__action-buttons" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-danger m-l-15",
                        on: { click: _vm.closeNodeProperties }
                      },
                      [_vm._v("\n          Close\n        ")]
                    )
                  ]
                )
              ],
              1
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }